<template>

	<div class="tagger modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<form class="form">

						<p>Click a tag to edit</p>

						<div
							v-for="(tagInfo, tagIndex) in tags" 
							:key="'tag-'+tagIndex"
						>
							<hr v-if="tagIndex>0" />

							<div class="tag-wrap">
								<input type="text" v-model="tags[tagIndex].tag" @click="editTag (tagIndex)" />
								<div class="button-wrap">
									<span class="large-button mini" v-if="editing===tagIndex&&tags[tagIndex].tag!==tagsOriginal[tagIndex].tag" @click="updateTag(tagIndex)">Update</span>
									<span class="large-button mini" v-if="editing===tagIndex" @click="editing=-1;tags[tagIndex].tag=tagsOriginal[tagIndex].tag">Cancel</span>
									<span class="large-button mini" v-if="editing!==tagIndex" @click="deleteTag(tagIndex)">Delete</span>
								</div>
							</div>

						</div>
						

					</form>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
export default {
	name: 'TagEditor',
	props: {
		project: {
			type: Object,
			default: () => {}
		},
	},
	data() {

		return {
			tags: [],
			tagsOriginal: [],
			editing: -1,
			needsReload: false
		}

	},
	computed: { 
		
		title () {

			return this.project.name + ': Edit/Delete Tags';

		}

    },

	methods: {

		...mapMutations('general',['updateLoadingText']),

		editTag (tagIndex) {
			
			this.editing = tagIndex;

		},

		deleteTag(tagIndex) {

			let tagInfo = { ...this.tags[tagIndex] };

			this.$dialog
				.confirm( `Are you sure you want to delete ${tagInfo.tag} from ${this.project.name} and remove it from any keywords?`, { okText: 'Yes', cancelText: 'Cancel'})
				.then(function() {

					this.updateLoadingText(true);

					ApiService.delete( `keywords/tags/${this.project._id}/${tagInfo._id}` )
					.then( function( info ) {

						this.tags.splice(tagIndex,1);
						this.tagsOriginal.splice(tagIndex,1);
						this.needsReload = true;
						this.updateLoadingText();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

						general.$snotify (this,'error','Delete Tag',err);

					}.bind(this));

				}.bind(this))
				.catch(function(err) {
					console.error(err);
				});

		},

		updateTag(tagIndex) {

			let tagInfo = { ...this.tags[tagIndex] };
			
			this.updateLoadingText(true);

			ApiService.put( `keywords/tags/${this.project._id}/${tagInfo._id}`, { tag: tagInfo.tag } )
				.then( function( info ) {

					this.tagsOriginal[tagIndex].tag = tagInfo.tag;
					this.needsReload = true;
					this.updateLoadingText();

				}.bind(this))
				.catch( function(err) {

					this.updateLoadingText();

					general.$snotify (this,'error','Update Tag',err);

				}.bind(this));

		},

		close() {

			this.$emit('close',this.needsReload);

		}
	},

	mounted() {

		ApiService.get( 'keywords/tags/' + this.project._id + '/1' )
			.then( function( info ) {

				this.updateLoadingText('');

				info.data.forEach( function (tag, index) {
					this.tags.push({ tag: tag.tag.tag, _id: tag.tag._id});
					this.tagsOriginal.push({ tag: tag.tag.tag, _id: tag.tag._id});
				}.bind(this));

			}.bind(this))
			.catch( function(a,b) {
				console.log('FAILURE!!',a,b);
			}.bind(this));

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.modal {
	.modal-inner-scroll {

		p {
			margin: 0 0 20px;
			color: @formDefaultColour;
		}

		.tag-wrap {

			display: flex;

			.button-wrap {

				margin: 0 0 0 20px;

				.large-button {

					margin: 7px 0 0;

				}

			}

			[type=text] {

				margin: 0;
				width: 280px;

				&:not(.editing) {

					background: none;
					cursor: default;

				}

			}

		}

	}
}
.modal-inner-scroll {

	min-height: 0px;

}

@media screen and (min-width: 768px) {
  
	.modal {

		

	}

}
</style>